import isequal from 'lodash.isequal';
import { useEffect, useRef } from 'react';
import { Animated, BackHandler, Dimensions, PanResponder } from 'react-native';
import { useSlideBack } from '../../hooks/useSlideBack';
const winWidth = Dimensions.get('window').width;
export function useSlidebackPan(props) {
    const { maxDx = winWidth / 2, maxDy = 300, enableSlideBackWhenClose = true, onClose, extraSetSlideBack, } = props;
    const pan = useRef(new Animated.ValueXY()).current;
    const dxyRef = useRef({
        dx: 0,
        dy: 0,
    });
    const { setSlideBack: nativeSetSlideBack } = useSlideBack(false);
    function setSlideBack(val) {
        nativeSetSlideBack(val);
        extraSetSlideBack === null || extraSetSlideBack === void 0 ? void 0 : extraSetSlideBack(val);
    }
    useEffect(() => {
        extraSetSlideBack === null || extraSetSlideBack === void 0 ? void 0 : extraSetSlideBack(false);
        return () => {
            setSlideBack(!!enableSlideBackWhenClose);
        };
    }, []);
    const panResponder = useRef(PanResponder.create({
        onMoveShouldSetPanResponder: () => true,
        onPanResponderMove: (e, state) => {
            if (state.dx < 0 || state.dy < 0)
                return;
            const newDxy = { dx: state.dx, dy: state.dy };
            if (!isequal(dxyRef.current, newDxy)) {
                let yVal = state.dy;
                if (state.dx > state.dy) {
                    yVal = state.dx * 1.5;
                }
                pan.y.setValue(yVal);
                dxyRef.current = newDxy;
            }
        },
        onPanResponderRelease: (e, state) => {
            if (state.dx > maxDx || state.dy > maxDy) {
                setSlideBack(!!enableSlideBackWhenClose);
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }
            else {
                Animated.spring(pan, {
                    useNativeDriver: false, // 一码多投h5，需要置为false
                    toValue: { x: 0, y: 0 },
                }).start();
            }
        },
    })).current;
    useEffect(() => {
        var _a;
        // 安卓里需要监听物理按键返回
        const removeHandler = (_a = BackHandler === null || BackHandler === void 0 ? void 0 : BackHandler.addEventListener) === null || _a === void 0 ? void 0 : _a.call(BackHandler, 'hardwareBackPress', () => {
            setSlideBack(!!enableSlideBackWhenClose);
            onClose === null || onClose === void 0 ? void 0 : onClose();
            return true;
        });
        return () => {
            var _a;
            (_a = removeHandler === null || removeHandler === void 0 ? void 0 : removeHandler.remove) === null || _a === void 0 ? void 0 : _a.call(removeHandler);
        };
    }, []);
    return {
        panResponder,
        panStyle: {
            transform: [{ translateY: pan.y }],
        },
    };
}
